import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import InitialLoader from "../../components/initial-loader";
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
// export const ourTokenKey = "token";
export const metaDataParamsKey = "m_data";
const Middleware = ({ children }) => {
    const location = useLocation();
    const [metadata, setMetadata] = useState(null);
    const [isLoginDone, setIsLoginDone] = useState(false);
    const [accessToken, setAccessToken] = useState(null);
    const afterLoginSuccess = () => {
        setIsLoginDone(true);
    };
    useEffect(() => {
        // Parse query parameters using query-string
        const { md, at } = queryString.parse(location.search);
        if (md) {
            try {
                const parsedMetadata = JSON.parse(md);
                sessionStorage.setItem(metaDataParamsKey, md);
                setMetadata(parsedMetadata);
            }
            catch (error) {
                console.error("Failed to parse metadata:", error);
            }
        }
        // Store access token
        setAccessToken(at);
        // localStorage.setItem(ourTokenKey, at as any);
    }, []);
    // if (!metadata) {
    //   return <p>Loading...</p>;
    // }
    return _jsx(_Fragment, { children: isLoginDone ? children : _jsx(InitialLoader, {}) });
};
export default Middleware;
